import { Collapse, Icon, Timeline } from '@oscar/theme';
import { REQUEST_STATUS } from 'common/constants';
import { forEach, has, isEmpty } from 'lodash';
import React, { Component } from 'react';
import { isEdit } from 'views/pages/create-instrulation/utils';
import { NodeItem, RequestDataType, Status } from '../../typed';
import { getRequestVisibile } from '../../utils';
import IconMinus from './components/IconMinus';
import './style.scss';

const { Panel } = Collapse;
interface WorkFlowProps {
  data: RequestDataType;
  status: Record<Status[number], string[]>;
  active?: Status;
  getStatusName: (status: Status) => string;
  statusRequest?: any;
  auth?: any;
  lastSubmitted?: number;
}
export default class WorkFlow extends Component<WorkFlowProps> {
  getIconName = (key: Status, childKey?: string) => {
    const { status, active, data, lastSubmitted } = this.props;
    let visibleStatus = {} as any;
    if (active && ['REJECTED', 'CANCELLED'].includes(active)) {
      let lastStatus: Status = active;
      forEach(REQUEST_STATUS, (value: any, name: any) => {
        if (value?.VALUE === lastSubmitted) {
          lastStatus = name;
        }
      });
      visibleStatus = getRequestVisibile(
        lastStatus,
        Object.keys(data) as Status[],
      );
    } else {
      visibleStatus = getRequestVisibile(
        active!,
        Object.keys(data) as Status[],
      );
    }
    if (
      visibleStatus.Done.includes(key) ||
      (active && ['REJECTED', 'CANCELLED'].includes(active) && key === 'CLOSED')
    ) {
      return 'process-icon-done';
    }
    if (visibleStatus.Waiting.includes(key)) {
      return 'process-icon-default';
    }
    if (childKey && !status[key].includes(childKey)) {
      return 'process-icon-done';
    }
    if (
      active &&
      ['REJECTED', 'CANCELLED'].includes(active) &&
      visibleStatus.Pending.includes(key)
    ) {
      return 'process-icon-default';
    }
    return 'process-icon-pending';
  };

  render() {
    const { status, active, data, getStatusName, statusRequest, auth } =
      this.props;
    const visibleStatus = getRequestVisibile(
      active!,
      Object.keys(data) as Status[],
    );

    return (
      <div className="work-flow">
        <div className="collapse-container">
          <Collapse
            bordered={false}
            defaultActiveKey={active && [active]}
            expandIcon={(panelProps: any) => {
              const key = panelProps.panelKey as Status;
              return (
                <IconMinus
                  primary={
                    (has(status, panelProps.panelKey) &&
                      isEmpty(status[key])) ||
                    visibleStatus.Done.includes(key)
                      ? true
                      : false
                  }
                  iconName={this.getIconName(key)}
                />
              );
            }}
          >
            {Object.keys(data).map(_key => {
              const key = _key as Status;
              const items = data[key];
              return (
                <Panel
                  className="process-header"
                  collapsible={
                    key !== active || items.length === 0 ? 'disabled' : 'header'
                  }
                  key={key}
                  header={
                    <span className="process-chil-ttl">
                      {getStatusName(key)}
                    </span>
                  }
                >
                  <Timeline>
                    <div className="process-child">
                      {items.map((item: NodeItem, i: number) => {
                        // todo (need to refactor)
                        if (
                          !item?.isVisibleByRole ||
                          (auth &&
                            statusRequest &&
                            isEdit(item.roles, statusRequest, auth))
                        ) {
                          return (
                            <Timeline.Item
                              className={'activeLine'}
                              dot={
                                <Icon
                                  icon={this.getIconName(key, item.key)}
                                  primary
                                  size={20}
                                />
                              }
                              key={i}
                            >
                              <p className="process-chil-ttl">{item?.header}</p>
                            </Timeline.Item>
                          );
                        }
                      })}
                    </div>
                  </Timeline>
                </Panel>
              );
            })}
          </Collapse>
        </div>
      </div>
    );
  }
}
